import { useTheme } from "@mui/material";
import {
  PDFHeaderDarkLogoS3,
  PDFHeaderLightLogoS3,
} from "@pages/platform-analysis/components/buttons/export-pdf/config";
import {
  FIRST_PAGE_HEADER_HEIGHT,
  MAX_PAGE_INDEX_TO_SHOW_MAIN_HEADER,
  PAGE_HEADER_HEIGHT,
  PAGE_HEADER_HEIGHT_NO_MAIN_HEADING,
} from "@pages/platform-analysis/components/buttons/export-pdf/constant";
import { useStyles } from "@pages/platform-analysis/components/buttons/export-pdf/styles";
import { Image, Text, View } from "@react-pdf/renderer";
import { defaultTo } from "lodash";

interface PDFPageHeaderProps {
  isFirstPage?: boolean;
  pageIndex?: number;
  shouldRemoveHeading?: boolean;
}

export const PDFPageHeader = ({
  isFirstPage = false,
  pageIndex,
  shouldRemoveHeading = defaultTo(pageIndex, 0) >
    MAX_PAGE_INDEX_TO_SHOW_MAIN_HEADER,
}: PDFPageHeaderProps) => {
  const { palette } = useTheme();
  const { pageStyle, typographyStyle } = useStyles();

  return (
    <View
      style={
        isFirstPage
          ? { ...pageStyle.header, height: FIRST_PAGE_HEADER_HEIGHT }
          : {
              ...pageStyle.header,
              height: shouldRemoveHeading
                ? PAGE_HEADER_HEIGHT_NO_MAIN_HEADING
                : PAGE_HEADER_HEIGHT,
            }
      }
    >
      <Image
        src={isFirstPage ? PDFHeaderDarkLogoS3 : PDFHeaderLightLogoS3}
        style={
          isFirstPage ? { width: 223, height: 46 } : { width: 172, height: 35 }
        }
      />

      {!shouldRemoveHeading && (
        <Text
          style={{
            ...(isFirstPage ? typographyStyle.h1 : typographyStyle.h2),
            color: isFirstPage ? palette.common.white : palette.common.black,
          }}
        >
          Platform analysis summary
        </Text>
      )}
    </View>
  );
};
